import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-transfer-entry-link',
  templateUrl: './asset-transfer-entry-link.component.html',
  styleUrls: ['./asset-transfer-entry-link.component.scss']
})
export class AssetTransferEntryLinkComponent {

}
